(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ld-disenos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ld-elegir]');
    if (!b) return;
    document.dispatchEvent(new CustomEvent('ld:elegir-variante', { detail: { id: b.dataset.ldElegir } }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-header"]) return;
  try {
    
  (function () {
    var cajas = document.querySelectorAll('[data-ld-rotar]');
    cajas.forEach(function (caja) {
      var msgs = caja.querySelectorAll('.ld-header__msg');
      if (msgs.length < 2) return;
      caja.classList.add('is-rotando');
      var i = 0; msgs[0].classList.add('is-activo');
      setInterval(function () {
        msgs[i].classList.remove('is-activo');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-activo');
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-hero"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ld-hero]').forEach(function (hero) {
      var variantes = JSON.parse(hero.querySelector('[data-ld-variantes]').textContent);
      var textos = JSON.parse(hero.querySelector('[data-ld-textos]').textContent);
      var slides = hero.querySelector('[data-ld-slides]');
      var minis = hero.querySelectorAll('[data-ld-mini]');
      var puntos = hero.querySelectorAll('.ld-hero__puntos span');
      var idInput = hero.querySelector('[data-ld-id]');
      var btn = hero.querySelector('[data-ld-comprar]');
      var btnTxt = hero.querySelector('[data-ld-comprar-texto]');
      var nombre = hero.querySelector('[data-ld-variante-nombre]');
      var precio = hero.querySelector('[data-ld-precio]');
      var precioFijo = hero.querySelector('[data-ld-precio-fijo]');

      function irAFoto(mediaId) {
        var s = slides && slides.querySelector('[data-media-id="' + mediaId + '"]');
        if (s) slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      }
      // Marca miniatura y punto activos al deslizar
      if (slides) {
        var t;
        slides.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var i = Math.round(slides.scrollLeft / slides.clientWidth);
            minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === i); });
            puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
          }, 60);
        });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { irAFoto(m.dataset.ldMini); }); });

      function elegir(id) {
        var v = variantes.find(function (x) { return String(x.id) === String(id); });
        if (!v) return;
        idInput.value = v.id;
        if (nombre) nombre.textContent = v.title;
        precio.innerHTML = v.precio;
        var stock = hero.querySelector('[data-ld-stock]');
        if (stock) stock.innerHTML = v.stock;
        if (precioFijo) precioFijo.innerHTML = v.precio;
        btn.disabled = !v.available;
        btnTxt.textContent = v.available ? textos.comprar : textos.agotado;
        if (v.media) irAFoto(v.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      hero.querySelectorAll('[data-ld-radio]').forEach(function (r) {
        r.addEventListener('change', function () { elegir(r.value); });
      });
      // Permite que otras secciones (Diseños disponibles) elijan una variante
      document.addEventListener('ld:elegir-variante', function (e) {
        var r = hero.querySelector('[data-ld-radio][value="' + e.detail.id + '"]');
        if (r) { r.checked = true; elegir(r.value); }
        hero.scrollIntoView({ behavior: 'smooth' });
      });

      // Cantidad
      var cant = hero.querySelector('input[name="quantity"]');
      hero.querySelector('[data-ld-menos]').addEventListener('click', function () { cant.value = Math.max(1, (+cant.value || 1) - 1); });
      hero.querySelector('[data-ld-mas]').addEventListener('click', function () { cant.value = Math.min(10, (+cant.value || 1) + 1); });

      // Computador: la galería queda centrada en la pantalla mientras baja la columna derecha
      var gal = hero.querySelector('.ld-hero__galeria');
      function centrarGaleria() {
        if (!gal) return;
        if (window.innerWidth < 990) { gal.style.top = ''; return; }
        var tope = Math.max(20, Math.round((window.innerHeight - gal.offsetHeight) / 2));
        gal.style.top = tope + 'px';
      }
      centrarGaleria();
      window.addEventListener('resize', centrarGaleria);
      window.addEventListener('load', centrarGaleria);

      // Botón fijo en celular: aparece cuando el botón principal sale de pantalla hacia arriba
      var fijo = hero.querySelector('[data-ld-fijo]');
      if (fijo && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
          fijo.classList.toggle('is-visible', visible);
          fijo.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }).observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-home-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ld-banner]').forEach(function (b) {
      var pista = b.querySelector('[data-ld-pista]');
      var puntos = b.querySelectorAll('[data-ld-ir]');
      if (!puntos.length) return;
      function ir(i) { pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' }); }
      puntos.forEach(function (p) { p.addEventListener('click', function () { ir(+p.dataset.ldIr); }); });
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / pista.clientWidth);
          puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        }, 60);
      });
      // Avance automático suave cada 6 s; se detiene si la persona toca el banner
      var auto = setInterval(function () {
        var i = Math.round(pista.scrollLeft / pista.clientWidth);
        ir((i + 1) % puntos.length);
      }, 6000);
      ['pointerdown', 'focusin'].forEach(function (ev) { b.addEventListener(ev, function () { clearInterval(auto); }, { once: true }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ld-video]').forEach(function (m) {
    var v = m.querySelector('video'), b = m.querySelector('[data-ld-sonido]');
    if (!v || !b) return;
    function activar() {
      v.muted = false; v.volume = 1;
      if (v.paused) v.play();
      b.hidden = true;
    }
    b.addEventListener('click', activar);
    // Si la persona sube el volumen desde los controles, el botón se oculta
    v.addEventListener('volumechange', function () { if (!v.muted) b.hidden = true; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
